import { create } from 'zustand';
import { AccountApi, AccountDetailsEntity, ApiUtils, RequestStrategyEnum } from '@shared/api';

interface IAccountDetailsStore {
  loading: boolean;
  error: string | null;
  account: AccountDetailsEntity | null;
  getAccountDetails: (accountCode: string, signal?: AbortSignal) => Promise<void>;
  clear: () => void;
}

export const useAccountDetailsStore = create<IAccountDetailsStore>((set) => ({
  loading: false,
  error: null,
  account: null,

  getAccountDetails: ApiUtils.wrapperApi(async (accountCode: string, signal?: AbortSignal) => {
    try {
      set({ loading: true, error: null });
      const result = await AccountApi.getAccountDetails(accountCode, signal);
      set({ account: result ?? null, loading: false });
    } catch (error) {
      set({ error: (error as Error).message, loading: false });
    }
  }, RequestStrategyEnum.Debounce),

  clear: () => set({ account: null, loading: false, error: null }),
}));
